import { createAsyncThunk } from "@reduxjs/toolkit";
import { IError } from "../types/common";
import {
  PayloadType,
  preparePayload,
} from "../../components/layouts/ReportsLayout/helper";
import { IReport } from "../../components/layouts/ReportsLayout/form/types";
import { IOptionalServiceSummaryColumns, IPatientReports, IReports } from "./types";

export const getGeneralReports = createAsyncThunk<
  IReports,
  { values: IReport },
  { rejectValue: IError }
>("reportsSlice/getGeneralReports", async (payload, { rejectWithValue }) => {
  try {
    return (await preparePayload(
      payload.values,
      PayloadType.generalPreview
    )) as IReports;
  } catch (error) {
    const { data } = error as {
      data: IError;
    };
    return rejectWithValue({ ...data });
  }
});

export const getPatientReports = createAsyncThunk<
  {
    reports: IPatientReports;
    selectedOptionalServiceColumns: IOptionalServiceSummaryColumns;
  },
  {
    values: IReport;
    selectedOptionalServiceColumns: IOptionalServiceSummaryColumns;
  },
  { rejectValue: IError }
>(
  "patientReportsSlice/getPatientReports",
  async (payload, { rejectWithValue }) => {
    try {
      return {
        reports: (await preparePayload(
          payload.values,
          PayloadType.patientPreview
        )) as IPatientReports,
        selectedOptionalServiceColumns: payload.selectedOptionalServiceColumns,
      };
    } catch (error) {
      const { data } = error as {
        data: IError;
      };
      return rejectWithValue({ ...data });
    }
  }
);
